module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-lang",
    attrs: {
      "slot": "activator",
      "flat": "",
      "dark": ""
    },
    slot: "activator"
  }, [_c('span', {
    staticClass: "icon-flag",
    class: {
      'es': _vm.lang.icon == 'es', 'en': _vm.lang.icon == 'en', 'ay': _vm.lang.icon == 'ay'
    }
  }), _vm._v(" " + _vm._s(_vm.lang.text) + "\n  ")]), _vm._v(" "), _c('v-list', _vm._l((_vm.languages), function(item) {
    return _c('v-list-tile', {
      key: item.title
    }, [_c('v-list-tile-title', {
      on: {
        "click": function($event) {
          return _vm.selectLang(item)
        }
      }
    }, [_c('span', {
      staticClass: "icon-flag",
      class: {
        'es': item.icon == 'es', 'en': item.icon == 'en', 'ay': item.icon == 'ay'
      }
    }), _vm._v(" " + _vm._s(item.text) + "\n      ")])], 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0a869f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/layout/AppLang.vue
// module id = 535
// module chunks = 2